import {
  adjustmentSessionIdFormat,
  locationIdFormat,
  packingTemplateIdFormat,
  productIdFormat,
} from "@redotech/redo-ids/ids";
import {
  PackingMode,
  PackingModeSchema,
} from "@redotech/redo-model/inventory/packing-mode";
import * as z from "zod";

const UpdateSessionProductSchema = z.object({
  productId: productIdFormat.schema,
  quantity: z.number(),
  damagedQuantity: z.number().optional(),
  missingQuantity: z.number().optional(),
  packingMode: PackingModeSchema.default(PackingMode.INDIVIDUAL),
  packingTemplateId: packingTemplateIdFormat.schema.nullable().optional(),
  enteredQuantity: z.number().default(0),
});

export const updateAdjustmentSession = {
  name: "updateAdjustmentSession" as const,
  input: z.object({
    sessionId: adjustmentSessionIdFormat.schema,
    locationId: locationIdFormat.schema,
    destinationLocationId: locationIdFormat.schema.optional(),
    sourceId: z.string(),
    products: z.array(UpdateSessionProductSchema),
    notes: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), sourceIdInUse: z.boolean() }),
};
